var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-cards",class:("product-cards--" + _vm.mode)},_vm._l((_vm.products),function(product,k){return _c('ProductCard',{key:'home_collection_' + k,staticClass:"product-cards__card",attrs:{"product":product}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }